import React from 'react';
import { Page, withModel } from '@adobe/aem-react-editable-components';
import ErrorBoundary from '../shared/ErrorBoundary';

// This component is the application entry point
class App extends Page {
	render() {
		return (
			<div className="App">
				<header className="App-header"></header>
				<ErrorBoundary>
					{this.childComponents}
					{this.childPages}
				</ErrorBoundary>
			</div>
		);
	}
}

export default withModel(App);
